var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M4 10h24a2 2 0 000-4H4a2 2 0 000 4zm24 4H4a2 2 0 000 4h24a2 2 0 000-4zm0 8H4a2 2 0 000 4h24a2 2 0 000-4z","fill":"currentColor"}})
}
var staticRenderFns = []

export { render, staticRenderFns }